import React from "react"
import styles from "./Battery.module.scss";



class Battery extends React.Component{
    render(){
        return (
            <div style={{
                display: "flex",
                position: "absolute",
                alignItems: "center",
                color: "white",
                zIndex: "1000",
                right: "15px",
                top: "20px"
            }} className={styles.battery_indicator}>
                <span className={styles.battery_tooltip}>Battery Indicator</span>
                <small style={{
                    marginRight: "8px",
                    color:this.props.mapview ? "#071C48" : "white"
                }}>70%</small>
                <div
                    style={{
                        zIndex: "1000",
                        background: this.props.mapview ? "#3E7AFF" : "white",
                        marginLeft: "1px",
                        height: "14px",
                        width: "6px",
                        borderRadius: "7px"
                    }}
                ></div>
                <div
                    style={{
                        zIndex: "1000",
                        background: this.props.mapview ? "#3E7AFF" : "white",
                        marginLeft: "1px",
                        height: "14px",
                        width: "6px",
                        borderRadius: "7px"
                    }}
                ></div>
                <div
                    style={{
                        zIndex: "1000",
                        background: this.props.mapview ? "#3E7AFF" : "white",
                        marginLeft: "1px",
                        height: "14px",
                        width: "6px",
                        borderRadius: "7px"
                    }}
                ></div>
                <div
                    style={{
                        zIndex: "1000",
                        background: this.props.mapview ? "#3E7AFF" : "white",
                        marginLeft: "1px",
                        height: "14px",
                        width: "6px",
                        borderRadius: "7px",
                        opacity: 0.3
                    }}
                ></div>
                <div
                    style={{
                        zIndex: "1000",
                        background: this.props.mapview ? "#3E7AFF" : "white",
                        marginLeft: "1px",
                        height: "14px",
                        width: "6px",
                        borderRadius: "7px",
                        opacity: 0.3
                    }}
                ></div>
            </div>
        )
    }
}

export default Battery;